// Fix for https://github.com/reduxjs/redux-toolkit/issues/1806#issuecomment-1536690651
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { WritableDraft } from '@reduxjs/toolkit/node_modules/immer/dist/internal';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createRoutine } from 'redux-saga-routines';

import { AnyRecord } from '../../utils/reduxToolkitUtils';

import { PromptProps, PromptPropsWithParams, ShowPromptPayloadRaw } from './PromptProvider.types';

const initialState = {
    portal: {
        open: false,
        ready: false,
        currentType: '' as string | undefined,
        params: undefined as AnyRecord | undefined,
    },

    modalPropsFn: () => ({}) as PromptProps,
};

// used only as promisifiedRoutine to await prompt confim/close action
// TODO: replace with RTK listenerMidleware
export const prompt = createRoutine('@@PROMPT/routine');

export const promptSlice = createSlice({
    name: '@@PROMPT',
    initialState,
    reducers: {
        showPrompt: {
            reducer(state, { payload }: PayloadAction<PromptPropsWithParams>) {
                const { type, params, ...modalProps } = payload;

                if (type === state.portal.currentType && state.portal.open) {
                    return;
                }

                state.modalPropsFn = () => modalProps;
                state.portal = { open: true, ready: false, currentType: type, params };
            },
            prepare({ config, resolve }: ShowPromptPayloadRaw) {
                const { confirmAction, ...promptConfig } = config;

                return {
                    payload: promptConfig,
                    meta: {
                        confirmAction,
                        deferred: resolve ? { resolve } : undefined,
                    },
                };
            },
        },

        addModalProps(state, { payload }: PayloadAction<PromptProps>) {
            const newModalProps = { ...state.modalPropsFn(), ...payload };
            state.modalPropsFn = () => newModalProps;
        },

        portalReady(state) {
            state.portal.ready = true;
        },

        reset() {
            return initialState;
        },
    },
});

export type PromptState = {
    [promptSlice.name]: ReturnType<typeof promptSlice.reducer>;
};

export const { addModalProps, showPrompt, portalReady, reset } = promptSlice.actions;

export default {
    /**
     * @deprecated don't use keyValuePair, use `promptSlice.name, promptSlice.reducer`
     */
    keyValuePair: {
        [promptSlice.name]: promptSlice.reducer,
    },
};
